import C from './constants'

export const address = (state = null, action) => (
  action.type == C.SET_ADDRESS ? action.payload : state
)

export const content = (state = null, action) => (
  action.type === C.SET_CONTENT
  ? action.payload
  : state
)

export const ethnicityOptions = (state=false, action) => (
  action.type === C.SET_ETHNICITY_OPTIONS
  ? action.payload
  : state
)

export const languageOptions = (state=false, action) => (
  action.type === C.SET_LANGUAGE_OPTIONS
  ? action.payload
  : state
)

export const page = (state = null, action) => (
  action.type === C.SET_PAGE
  ? action.payload
  : state
)


export const pages = (state = [], action) => (
  action.type === C.SET_PAGES
  ? action.payload
  : state
)


export const nextPage = (state = false, action) => (
  action.type === C.SET_NEXT_PAGE
  ? action.payload
  : state
)


export const previousPage = (state = false, action) => (
  action.type === C.SET_PREVIOUS_PAGE
  ? action.payload
  : state
)

export const profileElements = (state = [], action) => (
  action.type === C.SET_PROFILE_ELEMENTS
  ? action.payload
  : state
)

export const requiredFields = (state = [], action) => (
  action.type === C.SET_REQUIRED_FIELDS
  ? action.payload
  : state
)

export const territory = (state=false, action) => (
  action.type === C.SET_TERRITORY
  ? action.payload
  : state
)

export const recaptchaSiteId = (state = '', action) =>
  (action.type === C.SET_RECAPTCHA_SITE_ID) ?
    action.payload :
    state;

export const vaccinationMandatory = (state=[], action) =>
  (action.type === C.SET_VACCINATION_MANDATORY) ?
    action.payload :
    state;

export const authenticatedUser = (state={}, action) =>
  (action.type === C.SET_AUTHENTICATED_USER) ?
    action.payload :
    state;

export default {
  address,
  content,
  ethnicityOptions,
  languageOptions,
  nextPage,
  page,
  pages,
  previousPage,
  profileElements,
  requiredFields,
  territory,
  recaptchaSiteId,
  vaccinationMandatory,
  authenticatedUser
}
